import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { DebounceInput } from 'react-debounce-input';
import useCollections from '../../hooks/useCollections';

const CollectionSlug = ({ collection }) => {
    console.log("collection: ", collection);
    const [saving, setSaving] = useState(false);
    const { saveChangesToCollection } = useCollections();

    const updateCollectionSlug = async (e) => {
        console.log(e.target.value);
        setSaving(true);
        await saveChangesToCollection({ slug: e.target.value.trim(), docId: collection.docId });
        setSaving(false);
    };

    return (
        <div className="flex flex-col gap-4">
            <div className="pl-2 flex w-full flex-col gap-4 justify-start place-items-start">
                <div className="flex flex-row gap-4 justify-start place-items-center">
                    <div className="italic font-semibold">
                        Slug:
                    </div>
                    <div className="font-bold muted-text text-lg">
                        {collection !== null ? (
                            <DebounceInput
                                className="text-left dark:text-white hover:underline bg-transparent font-semibold border-none outline-none"
                                minLength={1}
                                value={collection.slug}
                                debounceTimeout={1000}
                                onChange={updateCollectionSlug}
                            />
                        ) : (
                            <span className="text-gray-500">Loading...</span>
                        )}
                    </div>
                    <div>
                        {saving && <FontAwesomeIcon icon={faSpinner} spin />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CollectionSlug;
